import { trans } from '@spotahome/soyuz/client';

import { isDefaultFilter } from '@spotahome/ui-library/src/tenant/components/utils/filters';

import {
  AGE,
  NATIONALITY,
  OCCUPATION,
  PROPERTY_TYPE_TO_SECTION_MAP,
  SECTION_ALL,
  SECTION_APARTMENT,
  SECTION_PROPERTY_TYPE_LABEL_MAP,
  SECTION_PROPERTY_TYPE_MAP,
  SECTION_RESIDENCE,
  SECTION_ROOM,
  SECTION_STUDIO
} from '../constants/seoCharts';

const MIN_PUBLISHED_PROPERTIES = 100;

export const shouldShowCharts = (totalPublishedProperties, filters) => {
  const onlyOnePropertyType = filters['type[]']?.length <= 1;

  return (
    totalPublishedProperties >= MIN_PUBLISHED_PROPERTIES &&
    onlyOnePropertyType &&
    isDefaultFilter(filters)
  );
};

export const getQueryPropertyType = propertyType =>
  propertyType in SECTION_PROPERTY_TYPE_MAP
    ? SECTION_PROPERTY_TYPE_MAP[propertyType]
    : null;

export const getPropertyTypeSections = () => [
  {
    id: SECTION_ALL,
    label: trans('charts.section.all-properties')
  },
  {
    id: SECTION_APARTMENT,
    label: trans('charts.section.apartments')
  },
  {
    id: SECTION_STUDIO,
    label: trans('charts.section.studios')
  },
  {
    id: SECTION_ROOM,
    label: trans('charts.section.rooms-shared')
  },
  {
    id: SECTION_RESIDENCE,
    label: trans('charts.section.student-residences')
  }
];

export const getTenantProfilesSections = () => [
  {
    id: NATIONALITY,
    label: trans('chart.section.nationality').toUpperCase()
  },
  {
    id: OCCUPATION,
    label: trans('chart.section.occupation').toUpperCase()
  },
  {
    id: AGE,
    label: trans('chart.section.age').toUpperCase()
  }
];

export const getPropertyTypeTranslation = propertyType => {
  if (SECTION_PROPERTY_TYPE_LABEL_MAP[propertyType]) {
    return trans(SECTION_PROPERTY_TYPE_LABEL_MAP[propertyType]).toLowerCase();
  }

  if (PROPERTY_TYPE_TO_SECTION_MAP[propertyType]) {
    return trans(
      SECTION_PROPERTY_TYPE_LABEL_MAP[
        PROPERTY_TYPE_TO_SECTION_MAP[propertyType]
      ]
    ).toLowerCase();
  }

  return '';
};
